import { Link } from 'react-router-dom';
import Reveal from '@/components/feature/Reveal';
import SectionHeader from './SectionHeader';

const agents = [
  {
    name: 'Agente Comercial',
    icon: 'ri-team-line',
    accent: 'text-secondary-400',
    funcs: ['Prospección', 'Seguimiento', 'Generación de propuestas', 'CRM'],
  },
  {
    name: 'Agente ERP',
    icon: 'ri-database-2-line',
    accent: 'text-primary-400',
    funcs: ['Consultar clientes', 'Stock', 'Pedidos', 'Documentos', 'Indicadores'],
  },
  {
    name: 'Agente de Soporte',
    icon: 'ri-customer-service-2-line',
    accent: 'text-accent-400',
    funcs: ['Responder consultas', 'Buscar documentación', 'Clasificar solicitudes', 'Escalar casos'],
  },
  {
    name: 'Agente Operacional',
    icon: 'ri-radar-line',
    accent: 'text-secondary-400',
    funcs: ['Monitorear procesos', 'Detectar anomalías', 'Generar alertas', 'Ejecutar automatizaciones'],
  },
];

const flow = ['Usuario', 'Agente IA', 'ACOMA', 'ERP · CRM · APIs · BD'];

export default function AgentsSection() {
  return (
    <section className="relative py-20 md:py-28 bg-background-900/40 border-y border-background-800/60 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] rounded-full bg-accent-500/10 blur-[140px]"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Agentes IA"
          title="Dale un equipo de agentes IA a tu empresa."
          subtitle="Los agentes de ACOMA pueden conectarse con las herramientas que tu empresa ya utiliza, consultar información y ejecutar tareas dentro de procesos reales."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {agents.map((agent, i) => (
            <Reveal key={agent.name} delay={i * 80}>
              <div className="h-full rounded-lg border border-background-700/60 bg-background-950/60 backdrop-blur p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent-500/40">
                <div className="flex items-center justify-between">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 border border-background-700/60">
                    <i className={`${agent.icon} ${agent.accent} text-xl`}></i>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-xs text-secondary-400 font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-secondary-500 animate-pulse-glow"></span>
                    Activo
                  </span>
                </div>
                <h3 className="mt-4 text-base md:text-lg font-bold font-heading text-foreground-950">
                  {agent.name}
                </h3>
                <div className="mt-4 flex flex-wrap gap-2">
                  {agent.funcs.map((f) => (
                    <span
                      key={f}
                      className="text-xs text-foreground-400 px-2.5 py-1 rounded-md bg-background-800/70 border border-background-700/50"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Connection flow */}
        <Reveal className="mt-12">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {flow.map((step, i) => (
              <div key={step} className="flex items-center gap-3">
                <span
                  className={`px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap ${
                    i === 1
                      ? 'bg-accent-500/15 text-accent-300 border border-accent-500/30'
                      : i === 2
                      ? 'bg-primary-500/15 text-primary-300 border border-primary-500/30'
                      : 'bg-background-800 text-foreground-400 border border-background-700/50'
                  }`}
                >
                  {step}
                </span>
                {i < flow.length - 1 && (
                  <span className="h-px w-6 md:w-10 bg-gradient-to-r from-primary-500/60 to-secondary-500/60 data-flow"></span>
                )}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-10 text-center">
          <Link
            to="/agentes-ia"
            className="inline-flex items-center gap-2 whitespace-nowrap font-medium text-background-950 bg-primary-500 hover:bg-primary-600 rounded-md px-7 py-3.5 transition-colors cursor-pointer glow-primary"
          >
            Descubre ACOMA Agents
            <i className="ri-arrow-right-line"></i>
          </Link>
          <p className="mt-4 text-sm text-foreground-500">
            Próximamente podrás crear y administrar los agentes de tu empresa
            directamente desde ACOMA.
          </p>
        </Reveal>
      </div>
    </section>
  );
}